import React from "react";
import PropTypes from "prop-types";
import { Grid, Table, TableBody, TableContainer, TableRow, Paper } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";

const PresetDataTable = ({ presetData }) => {
  if (!presetData || presetData.length === 0) {
    return null;
  }

  const columns = Object.keys(presetData[0]).map((column) => ({
    field: column,
    headerName: column,
    align: "left",
  }));

  return (
    <Grid item xs={12}>
      <MDTypography variant="h6" gutterBottom>
        Preset Data Preview
      </MDTypography>
      <TableContainer component={Paper} style={{ maxHeight: 400 }}>
        <Table stickyHeader>
          <MDBox component="thead">
            <TableRow>
              {columns.map((column, index) => (
                <DataTableHeadCell key={index} width="auto" align={column.align}>
                  {column.headerName}
                </DataTableHeadCell>
              ))}
            </TableRow>
          </MDBox>
          <TableBody>
            {presetData.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map((column, columnIndex) => (
                  <DataTableBodyCell key={columnIndex} align={column.align}>
                    {row[column.field]}
                  </DataTableBodyCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

PresetDataTable.propTypes = {
  presetData: PropTypes.arrayOf(PropTypes.object),
};

PresetDataTable.defaultProps = {
  presetData: [],
};

export default PresetDataTable;
